import React from "react";

import classNames from "classnames";
import Link from "next/link";

import { Button } from "studio-design-system";

import * as styles from "./HeaderButtons.css";

export interface HeaderButtonProps {
  label?: string;
  href?: string;
  onClick?: () => void;
  className?: string;
  custom?: React.ReactNode;
}

interface Props {
  items: Array<HeaderButtonProps>;
  className?: string;
}

export const HeaderButtons = ({ items, className }: Props) => {
  return (
    <div className={classNames(styles.headerButtonContainer, className)}>
      {items.map((item, index) => {
        if (item.custom) {
          return item.custom;
        }
        if (item.href) {
          return (
            <Link href={item.href} key={index}>
              <Button
                variant="transparent"
                className={classNames(styles.headerButton, item.className)}
                buttonSize="medium"
              >
                {item.label}
              </Button>
            </Link>
          );
        } else if (item.onClick) {
          return (
            <Button
              variant="transparent"
              className={classNames(styles.headerButton, item.className)}
              buttonSize="medium"
              onClick={item.onClick}
              key={index}
            >
              {item.label}
            </Button>
          );
        }
      })}
    </div>
  );
};
